import clsx from 'clsx'
import React from 'react'
import { Button as AriaButton, OverlayArrow, Tooltip as AriaTooltip, TooltipTrigger } from 'react-aria-components'

import type { IProps } from './interfaces'
import styles from './styles.module.scss'

const DEFAULT_DELAY = 300

/**
 * A short label on hover and keyboard focus (DS: ink ground, light text). The trigger is any content
 * in a plain focusable wrapper that keeps the content's look, or a focusable kit element.
 */
export const Tooltip = ({
  content,
  children,
  trigger = 'plain',
  triggerLabel,
  triggerClassName,
  triggerTestId,
  placement = 'top',
  delay = DEFAULT_DELAY,
  defaultOpen,
  isDisabled = false,
  shouldCloseOnPress = true,
  'data-testid': testId,
}: IProps): React.JSX.Element => (
  <TooltipTrigger
    delay={delay}
    defaultOpen={defaultOpen}
    isDisabled={isDisabled}
    shouldCloseOnPress={shouldCloseOnPress}
  >
    {trigger === 'plain' ? (
      <AriaButton
        className={clsx(styles.plainTrigger, triggerClassName)}
        aria-label={triggerLabel}
        data-testid={triggerTestId}
      >
        {children}
      </AriaButton>
    ) : (
      children
    )}
    <AriaTooltip className={styles.tooltip} placement={placement} offset={8} data-testid={testId}>
      <OverlayArrow className={styles.arrow}>
        <svg width={8} height={8} viewBox="0 0 8 8" aria-hidden="true">
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {content}
    </AriaTooltip>
  </TooltipTrigger>
)

export type { TTooltipPlacement } from './interfaces'
